import { indexItems } from '@/mocks/movies';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            电影索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            按类型快速浏览，高分电影在线尽在掌握
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer flex items-center gap-3"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 font-heading font-bold text-lg flex-shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                {item.letter}
              </div>
              <div className="min-w-0">
                <h3 className="font-medium text-sm md:text-base text-foreground-900 whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.count} 部</p>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#cards"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer"
          >
            查看全部电影分类
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}